import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lpu-address" },
    [
      _setup.isMobile
        ? _c(_setup.InfoCard, {
            staticClass: "cursor-pointer gr-3",
            attrs: {
              "data-popup-map": _setup.popupMapJson,
              icon: "ui-icon-place-40",
              title: `${_setup.tStatic("Адрес")}:`,
              subtitle: _setup.tDynamic(_setup.lpuAddress, "address"),
            },
            on: { click: _setup.handlePopupMapClick },
            scopedSlots: _vm._u(
              [
                _vm.lpu.lpumetro_set?.all.length
                  ? {
                      key: "extra-content",
                      fn: function () {
                        return [
                          _c(VDivider),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex flex-column gr-4" },
                            _vm._l(
                              _vm.lpu.lpumetro_set.all,
                              function (lpuMetro, index) {
                                return _c(
                                  "div",
                                  {
                                    key: `lpu-metro-${index}`,
                                    staticClass:
                                      "d-flex align-start text-body-1 gc-2",
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "lpu-address__metro-color flex-shrink-0",
                                      style: {
                                        backgroundColor: lpuMetro.metro.color,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "text-secondary--text" },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              _setup.tDynamic(
                                                lpuMetro.metro,
                                                "name"
                                              )
                                            ) +
                                            "\n          "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-inline-flex align-center gc-1 flex-shrink-0 ml-auto",
                                      },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "ui-icon-pedestrian icon-secondary--text",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-secondary--text",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  lpuMetro.walk_time < 60
                                                    ? "1"
                                                    : Math.floor(
                                                        lpuMetro.walk_time / 60
                                                      )
                                                ) +
                                                " " +
                                                _vm._s(_setup.tStatic("мин")) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        : !_vm.lpu.lpumetro_set?.all.length
        ? _c(_setup.InfoCard, {
            staticClass: "cursor-pointer",
            attrs: {
              "data-popup-map": _setup.popupMapJson,
              icon: "ui-icon-place-40",
              title: `${_setup.tStatic("Адрес")}:`,
              subtitle: _setup.tDynamic(_setup.lpuAddress, "address"),
            },
            on: { click: _setup.handlePopupMapClick },
          })
        : _c(
            VMenu,
            {
              staticClass: "lpu-address__metro-menu",
              attrs: {
                attach: "",
                "min-width": "400",
                "max-width": "400",
                "nudge-bottom": "12",
                "z-index": "110",
                "allow-overflow": false,
                "close-on-content-click": false,
                "open-on-hover": !_setup.isMobile,
                "offset-y": "",
                right: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ attrs, on, value }) {
                    return [
                      _c(
                        _setup.InfoCard,
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "cursor-pointer",
                              attrs: {
                                icon: "ui-icon-place-40",
                                "data-popup-map": _setup.popupMapJson,
                                title: `${_setup.tStatic("Адрес")}:`,
                                subtitle: _setup.tDynamic(
                                  _setup.lpuAddress,
                                  "address"
                                ),
                                "use-hover": "",
                              },
                              on: { click: _setup.handlePopupMapClick },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "subtitle-append-icon",
                                    fn: function () {
                                      return [
                                        _c("span", {
                                          staticClass:
                                            "icon-secondary--text ui-icon-arrow-down lpu-address__menu-icon",
                                          class: {
                                            "lpu-address__menu-icon--rotate-up":
                                              value,
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            "InfoCard",
                            attrs,
                            false
                          ),
                          on
                        )
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _vm._l(_vm.lpu.lpumetro_set?.all, function (lpuMetro, index) {
                return _c(
                  "div",
                  {
                    key: `lpu-metro-${index}`,
                    staticClass: "d-flex align-start text-body-1 gc-2",
                  },
                  [
                    _c("span", {
                      staticClass: "lpu-address__metro-color flex-shrink-0",
                      style: { backgroundColor: lpuMetro.metro.color },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-secondary--text" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.tDynamic(lpuMetro.metro, "name")) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "d-inline-flex align-center gc-2 flex-shrink-0 ml-auto",
                      },
                      [
                        _c("span", {
                          staticClass:
                            "ui-icon-pedestrian icon-secondary--text",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-secondary--text" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                lpuMetro.walk_time < 60
                                  ? "1"
                                  : Math.floor(lpuMetro.walk_time / 60)
                              ) +
                              " " +
                              _vm._s(_setup.tStatic("мин")) +
                              "\n        "
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }